import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { devicesScreen } from '@/ui/pages/Devices/devicesScreen';

/** HS-869: the list is a `@smartsash/data-screen` definition — see `groups.index.tsx`. */
const DevicesListScreen = devicesScreen.ListScreen;

export const Route = createFileRoute('/_dashboard/devices/')({
  validateSearch: devicesScreen.validateSearch,
  loaderDeps: devicesScreen.loaderDeps,
  beforeLoad: requireRoute('/devices'),
  loader: devicesScreen.loaderFor(),
  component: DevicesListScreen,
});
